import { Role } from '../role.js';
const emptyConfirmationTextConfig = () => ({
    mode: 'system',
    customText: ''
});
const toConfirmationTextConfig = (raw) => {
    const result = emptyConfirmationTextConfig();
    if (!raw || typeof raw !== 'object')
        return result;
    const data = raw;
    if (data.mode === 'system' ||
        data.mode === 'prepend' ||
        data.mode === 'append' ||
        data.mode === 'replace') {
        result.mode = data.mode;
    }
    if (typeof data.customText === 'string') {
        result.customText = data.customText;
    }
    return result;
};
// Admin forms have stored this as a number, a numeric string and even "9d".
// A cleared or unreadable value falls back to 30; a stored 0 stays 0.
const toAvailableFromDays = (raw) => {
    const n = parseInt(String(raw ?? ''), 10);
    return Number.isFinite(n) && n >= 0 ? n : 30;
};
const toSiteSettings = (raw) => {
    return {
        bookingOpen: !!raw.bookingOpen,
        siteOpen: !!raw.siteOpen,
        closed: !!raw.closed,
        closedMessage: raw.closedMessage || '',
        siteMessage: raw.siteMessage || '',
        bookingMessage: raw.bookingMessage || '',
        defaultAvailableFromDays: toAvailableFromDays(raw.defaultAvailableFromDays),
        bookingInPastHours: raw.bookingInPastHours || 1,
        timezone: raw.timezone || 'Europe/Oslo',
        confirmationText: toConfirmationTextConfig(raw.confirmationText),
        showPublicNamesOnTicket: raw.showPublicNamesOnTicket ?? true,
        defaultSlotPickerView: raw.defaultSlotPickerView === 'month' ? 'month' : 'day',
        // Resolved against the legacy field in toSiteData; see there.
        payOutsideSystemRole: Role.bookie
    };
};
const emptySiteSettings = () => {
    return {
        bookingOpen: true,
        siteOpen: true,
        closed: false,
        closedMessage: '',
        siteMessage: '',
        defaultAvailableFromDays: 30,
        bookingMessage: '',
        bookingInPastHours: 0,
        timezone: 'Europe/Oslo',
        confirmationText: emptyConfirmationTextConfig(),
        showPublicNamesOnTicket: true,
        defaultSlotPickerView: 'day',
        payOutsideSystemRole: Role.bookie
    };
};
export { emptySiteSettings, toSiteSettings, emptyConfirmationTextConfig, toConfirmationTextConfig };
//# sourceMappingURL=siteSettings.js.map